import PieChartGraph from './PieChart';

export default PieChartGraph;
